import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TaiwanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16078'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16078)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.953125 14.9333H20.9516V-0.93335H-0.953125V14.9333Z'
					fill='#FE3030'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.953125 7.46665H10.4754V-0.93335H-0.953125V7.46665Z'
					fill='#0909B6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.23837 4.90002L4.32722 5.88908L4.39658 4.55832L3.03866 4.62629L4.0479 3.73336L3.03866 2.84043L4.39658 2.9084L4.32722 1.57764L5.23837 2.56669L6.14953 1.57764L6.08017 2.9084L7.43809 2.84043L6.42885 3.73336L7.43809 4.62629L6.08017 4.55832L6.14953 5.88908L5.23837 4.90002Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TaiwanFlagIcon;
